import { render, staticRenderFns } from "./ConsultAppointment.vue?vue&type=template&id=0f455533&scoped=true"
import script from "./ConsultAppointment.vue?vue&type=script&lang=js"
export * from "./ConsultAppointment.vue?vue&type=script&lang=js"
import style0 from "./ConsultAppointment.vue?vue&type=style&index=0&id=0f455533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f455533",
  null
  
)

export default component.exports